import { ValidatorInterface } from "../validator-interface";
import { isEmpty } from "../utils/validator-utils";
import { z } from "zod";
export class FloatOnlyValidator extends ValidatorInterface {
    getZodSchema(baseSchema, options = {}) {
        const message = options.message || "Please enter a valid float";
        // options.value will be the value provided in data-zod-rules="myCustomRule=someValue"
        // options.message is the custom message if provided
        // options.labelText is the determined label for the field
        return baseSchema.refine(
            val => {
                if (isEmpty(val)) return true;
                // Accept Decimals (1.0, 3.14) OR zero (0)
                const floatPattern = z.string().regex(/^(\d*\.\d+|0+)$/);
                return floatPattern.safeParse(val).success;
            },
            { message }
        );
    }

    getErrorMessage(field, options) {
        // This is typically used by validateExternal if it sets an error
        // Zod refinements usually define their message directly
        return options.message || "Please enter a valid float";
    }
}
